import React from "react";

const ClockIcon = ({ height = 14.927, width = 14.927 }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14.927 14.927"
      >
        <path
          id="clock-regular"
          d="M15.463,8a7.464,7.464,0,1,0,7.463,7.464A7.462,7.462,0,0,0,15.463,8Zm0,13.482a6.019,6.019,0,1,1,6.019-6.019A6.017,6.017,0,0,1,15.463,21.482Zm1.86-3.142-2.555-1.857a.363.363,0,0,1-.147-.292V11.25a.362.362,0,0,1,.361-.361h.963a.362.362,0,0,1,.361.361v4.264l2.01,1.463a.361.361,0,0,1,.078.506l-.566.779A.364.364,0,0,1,17.323,18.341Z"
          transform="translate(-8 -8)"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};
export default ClockIcon;
